 <div class="footer border-t border-text py-4 px-5 mt-5 text-center text-text text-sm">
        <p>© Copyright | All rights reserved.</p>
    </div>